class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          // const offerTextContainer = document.querySelector("cart-drawer .header__icon.header__icon--summary");
          // if (offerTextContainer) {
          //   const offerText = offerTextContainer.getAttribute("data-offer-text"), couponCode = offerTextContainer.getAttribute("data-discount-code");
          //   if (offerText) {
          //     this.querySelector(".order-getreward").innerText = offerText;
          //   }
          //   if (couponCode && couponCode != "null") {
          //     this.querySelector(".top_box_1").style.display = 'block';
          //     this.querySelector(".top_box_1 .reedem_points").innerText = couponCode;
          //   } else {
          //     this.querySelector(".top_box_1").style.display = 'none';
          //   }
          // }
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
          updateCartRewards();
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
          updateCartRewards();
      }
    }));
    // const offerTextContainer = document.querySelector("cart-drawer .header__icon.header__icon--summary");
    // if (offerTextContainer) {
    //   const offerText = offerTextContainer.getAttribute("data-offer-text"), couponCode = offerTextContainer.getAttribute("data-discount-code");
    //   if (offerText) {
    //     this.querySelector(".order-getreward").innerText = offerText;
    //   }
    //   if (couponCode) {
    //     this.querySelector(".top_box_1").style.display = 'block';
    //     this.querySelector(".top_box_1 .reedem_points").innerText = couponCode;
    //   } else {
    //     this.querySelector(".top_box_1").style.display = 'none';
    //   }
    // }

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'bottom-nav',
        section: 'bottom-nav',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);
